import { useEffect } from "react";
import { useRouter } from "next/router";

import CareersDetailPage from "@/containers/CareersDetailPage";
import { renderMetaData } from "@/utils";
//Redux
import { wrapper } from "@/redux/Store";
import * as dashboardActions from "@/redux/DashboardReducer";

import * as actions from "@/redux/CareersPageReducer";

import { useAppDispatch } from "@/hooks";

const CareersDetail = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const { jobId } = router.query;

  useEffect(() => {
    dispatch(actions.getJobDetailsById({ jobId }));
  }, [dispatch, jobId]);

  const metaData = {
    siteName: "Shyft",
    siteURL: "https://www.betheshyft.com/careers",
    title: "Careers at Shyft",
    description: "Find different roles available at Shyft health",
    thumbnail: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/logo-c305d1c2dc6e4a9cb2d7767c4d9c213b.png",
    h1Text: "Careers at Shyft",
  };

  const metaTags = renderMetaData(metaData);

  return (
    <>
      {metaTags}
      <main>
        <CareersDetailPage />
      </main>
    </>
  );
};

export default CareersDetail;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ query }) => {

      await store.dispatch(
        dashboardActions.getRibbonData({ pathname: "careers" })
      );

      await store.dispatch(actions.getJobDetailsById({ jobId: query?.jobId }));

      // if (!res?.payload) {
      //   return {
      //     notFound: true,
      //   };
      // }
    }
);
